document.querySelectorAll('[data-fibrax-calculator]').forEach((root) => {
  if (root.dataset.fxReady) return;
  root.dataset.fxReady = 'true';
  const $ = (selector) => root.querySelector(selector);
  const apps = {
    mortar: {
      label: 'Mortero y aplanado', product: 'Duomix M20', type: 'Microfibra de polipropileno',
      dose: 0.6, min: 0, packageKg: 18, packageLabel: 'caja', packageContents: '30 bolsas de 0.60 kg',
      engineering: false, variant: root.dataset.duomixVariant
    },
    sidewalk: {
      label: 'Banqueta', product: 'Synmix EZ54', type: 'Macrofibra sintética',
      dose: 1.8, min: 0, packageKg: 10.86, packageLabel: 'caja', packageContents: '6 bolsas de 1.81 kg',
      engineering: false, variant: root.dataset.synmixVariant
    },
    garage: {
      label: 'Cochera residencial', product: 'Synmix EZ54', type: 'Macrofibra sintética',
      dose: 2.4, min: 0, packageKg: 10.86, packageLabel: 'caja', packageContents: '6 bolsas de 1.81 kg',
      engineering: false, variant: root.dataset.synmixVariant
    },
    patio: {
      label: 'Patio o firme', product: 'Synmix EZ54', type: 'Macrofibra sintética',
      dose: 1.8, min: 0, packageKg: 10.86, packageLabel: 'caja', packageContents: '6 bolsas de 1.81 kg',
      engineering: false, variant: root.dataset.synmixVariant
    },
    commercial: {
      label: 'Piso comercial', product: 'Synmix EZ54', type: 'Macrofibra sintética estructural',
      dose: 3, min: 0, packageKg: 10.86, packageLabel: 'caja', packageContents: '6 bolsas de 1.81 kg',
      engineering: true, variant: root.dataset.synmixVariant
    },
    lightIndustrial: {
      label: 'Nave industrial · carga ligera', product: 'Synmix EZ54', type: 'Macrofibra sintética estructural',
      dose: 3, min: 15, packageKg: 10.86, packageLabel: 'caja', packageContents: '6 bolsas de 1.81 kg',
      engineering: true, variant: root.dataset.synmixVariant
    },
    heavyIndustrial: {
      label: 'Nave industrial · carga pesada', product: 'Dramix 4D 80/60BGE', type: 'Fibra metálica',
      dose: 10, min: 15, packageKg: 20, packageLabel: 'saco', packageContents: '1 saco de 20 kg',
      engineering: true, variant: root.dataset.dramixVariant
    },
    pavement: {
      label: 'Calle o pavimento', product: 'Synmix EZ54', type: 'Macrofibra sintética estructural',
      dose: 3, min: 18, packageKg: 10.86, packageLabel: 'caja', packageContents: '6 bolsas de 1.81 kg',
      engineering: true, variant: root.dataset.synmixVariant
    }
  };

  const plural = (n, singular, pluralWord) => n === 1 ? singular : pluralWord;
  const selected = () => root.querySelector('input[name="fx-application-' + root.dataset.sectionId + '"]:checked')?.value || 'sidewalk';

  const closedPackages = (app, targetKg) => {
    const count = Math.max(1, Math.ceil(targetKg / app.packageKg));
    const pluralLabel = app.packageLabel === 'caja' ? 'cajas' : 'sacos';
    return {
      count,
      kg: count * app.packageKg,
      summary: app.packageLabel === 'caja'
        ? `${count} ${plural(count, 'caja', 'cajas')} ${count === 1 ? 'cerrada' : 'cerradas'}`
        : `${count} ${plural(count, 'saco', 'sacos')} ${count === 1 ? 'completo' : 'completos'}`,
      detail: `${count.toLocaleString('es-MX')} ${plural(count, app.packageLabel, pluralLabel)} de ${app.packageKg.toFixed(2)} kg · ${app.packageContents}`
    };
  };

  let current = null;
  const calculate = () => {
    const app = apps[selected()];
    const area = Math.max(0, Number($('[data-fx-area]')?.value || 0));
    let thickness = Math.max(1, Number($('[data-fx-thickness]')?.value || 1));
    const contingency = Math.max(0, Number($('[data-fx-contingency]')?.value || 0));
    const notice = $('[data-fx-thickness-notice]');

    if (app.min && thickness < app.min) {
      thickness = app.min;
      $('[data-fx-thickness]').value = app.min;
      notice.hidden = false;
      notice.textContent = `Para esta aplicación se aplicó el espesor mínimo de ${app.min} cm.`;
    } else {
      notice.hidden = true;
    }
    $('[data-fx-thickness]').min = app.min || 1;

    const volume = area * thickness / 100;
    const designKg = volume * app.dose;
    const targetKg = designKg * (1 + contingency);
    const purchase = closedPackages(app, targetKg);
    const overage = Math.max(0, purchase.kg - targetKg);
    current = { app, purchase, area, thickness, designKg, targetKg, volume };

    $('[data-fx-result-application]').textContent = app.label;
    $('[data-fx-product-name]').textContent = app.product;
    $('[data-fx-product-type]').textContent = app.type;
    $('[data-fx-dose]').textContent = `${app.dose.toFixed(2)} kg/m³`;
    $('[data-fx-volume]').textContent = `${volume.toFixed(2)} m³`;
    $('[data-fx-design-fiber]').textContent = `${designKg.toFixed(2)} kg`;
    $('[data-fx-target-fiber]').textContent = `${targetKg.toFixed(2)} kg`;
    $('[data-fx-supplied]').textContent = `${purchase.kg.toFixed(2)} kg`;
    $('[data-fx-purchase-summary]').textContent = purchase.summary;
    $('[data-fx-purchase-detail]').textContent = purchase.detail;
    $('[data-fx-overage]').textContent = `${overage.toFixed(2)} kg`;
    $('[data-fx-engineering]').hidden = !app.engineering;
  };

  root.querySelectorAll('input[name="fx-application-' + root.dataset.sectionId + '"]').forEach((input) => input.addEventListener('change', calculate));
  ['[data-fx-area]', '[data-fx-thickness]', '[data-fx-contingency]'].forEach((selector) => $(selector)?.addEventListener('change', calculate));
  $('[data-fx-calculate]')?.addEventListener('click', calculate);
  $('[data-fx-add-calculation]')?.addEventListener('click', (event) => {
    if (!current) calculate();
    window.FibraxCore.addToCart({
      variantId: current.app.variant,
      quantity: current.purchase.count,
      unitLabel: current.app.packageLabel,
      root,
      button: event.currentTarget,
      properties: {
        Aplicación: current.app.label,
        Dosificación: `${current.app.dose.toFixed(2)} kg/m³`,
        Superficie: `${current.area} m²`,
        Espesor: `${current.thickness} cm`,
        Presentación: `${current.app.packageLabel === 'caja' ? 'Caja cerrada' : 'Saco completo'} de ${current.app.packageKg.toFixed(2)} kg`,
        Contenido: current.app.packageContents
      }
    });
  });
  $('[data-fx-advisor]')?.addEventListener('click', () => {
    if (!current) calculate();
    window.location.href = window.FibraxCore.withQuery(root.dataset.advisorUrl, {
      aplicacion: current.app.label,
      producto: current.app.product,
      superficie: `${current.area} m²`,
      espesor: `${current.thickness} cm`,
      fibra: `${current.targetKg.toFixed(2)} kg`,
      compra: current.purchase.summary
    });
  });
  calculate();
});
